<template>
  <div class="modal fade" id="successMsgModal">
    <div class="modal-dialog" :class="{'success-modal-wrapper': !isTeamMember}">
      <div class="modal-content expiry-modal-content">
        <div class="modal-header">
          <div class="card text-center">
            <img src="static/images/icons/checkbox.svg" :class="[isTeamMember ? 'success_new_logo card-img-top' : 'success_logo card-img-top']" />
            <!-- <div v-if="showMessage" class="card-body">
              <div class="card-title">
                <p class="first-card-title update-failed title_text">Thank you for your purchase</p>
              </div>
            </div> -->
            <div class="card-title">
              <p :class="[isTeamMember?'new_title_text':'first-card-title update-success title_text']">{{ $t('success')}}</p>
            </div>
            <div class="row">
              <div class="col-lg-12 card-text">
                <p v-if="!isTeamMember" class="success-message" :class="{'pb-0 mb-0': renew}">{{successMessage}}</p>
                <p v-else class="new-success-message" :class="{'pb-0 mb-0': renew}">{{successMessage}}</p>
              </div>
              <!-- <div v-if="showMessage" class="col-lg-12 error-message">View services and billing under your
                <div><a @click="redirectToServices">account settings</a></div>
              </div> -->
            </div>
            <div class="row" v-if="payment_option == 1">
              <div class="col-lg-12 card-text">
              <h5 class="success-message"  :class="{'pt-0': renew}">
                <span v-if="!renew">*</span>
                <span>Clicking OK will redirect you to marketplace page</span>
              </h5>
              </div>
              </div>
              <div class="row" v-if="(payment_option == 2 || payment_option == 3 || payment_option === 1) && renew">
              <div class="col-lg-12 card-text">
              <h5 class="success-message fs-16">
                * Changes will reflect at the start of your next billing period pending payment.
              </h5>
              </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 ok-btn" :class="{ 'text-center': isTeamMember }">
                <button
                  :class="[isTeamMember ? 'emergo-new-blue-button' : 'btn btn-block emergo-blue-button']"
                  @click="submitModal"
                >OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';

export default {
  props: ['serviceSelected', 'successMessage', 'redirection', 'payment_option', 'showMessage', 'renew', 'isTeamMember'],
  methods: {
    redirectToServices() {
      $('#successMsgModal').modal('hide');
      EventBus.$emit('openAccountSettingsPopup', 'services');
      this.$router.push('/layout/market-place');
    },
    submitModal() {
      if (this.redirection) {
        this.$router.push(this.redirection);
      }
      this.$emit('closeParent');
      $('#successMsgModal').modal('hide');
    },
  },

};
</script>

<style scoped>
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  background: #f2f2f2;
  border-radius: 10px;
}
.card .card-body .card-text p.first-card-text {
  padding-top: 30px;
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 0px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
}
.fs-16 {
  font-size: 16px !important;
}
img.success_logo.card-img-top {
    width: 50px;
    height: 50px;
    background-color: #4C9E45;
    border-radius: 50%;
    padding: 10px;
    margin-top: 5px;
}
.error-message, .success-message {
  padding-top: 10px;
  padding-bottom: 20px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  font-size: 18px;
  font-weight: 300;
}
.ok-btn {
  width: 50%;
  margin: auto;
  float: initial;
}
p.first-card-title.update-success {
  font-size: 25px;
  padding-top: 25px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 500;
}
.mb-0 {
  margin-bottom: 0px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pt-0 {
  padding-top: 0px;
}

.emergo-new-blue-button {
  background: #01518a;
  border: 5px solid #01518a;
  border-radius: 5px;
  min-width: 132px;
  height: 44px;
  color: white;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 9px;
}

img.success_new_logo.card-img-top {
  width: 45px;
  height: 45px;
  background-color: #4C9E45;
  border-radius: 50%;
  padding: 10px;
  margin-top: 22px;
}

.new_title_text {
  padding-top: 25px;
  color: #333333;
  font-weight: 500;
  font-weight: 300;
  font-size: 24px;
  line-height: 33px;
  margin-bottom: 0px;
}

.new-error-message,
.new-success-message {
  padding-top: 8px;
  padding-bottom: 24px;
  color: #333333;
  line-height: 22px;
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 0px;
}
@media screen and (min-width: 768px) {
  .success-modal-wrapper{
    width: 500px;
  }
  .modal-dialog.success-modal-wrapper {
    margin: 0;
  }
}
</style>
